export var ThorchainMessageType;
(function (ThorchainMessageType) {
    ThorchainMessageType["MsgDeposit"] = "thorchain/MsgDeposit";
    ThorchainMessageType["MsgSend"] = "thorchain/MsgSend";
})(ThorchainMessageType || (ThorchainMessageType = {}));
export var MayachainMessageType;
(function (MayachainMessageType) {
    MayachainMessageType["MsgDeposit"] = "mayachain/MsgDeposit";
    MayachainMessageType["MsgSend"] = "mayachain/MsgSend";
})(MayachainMessageType || (MayachainMessageType = {}));
export var CosmosSdkMessageType;
(function (CosmosSdkMessageType) {
    CosmosSdkMessageType["MsgBeginRedelegate"] = "cosmos-sdk/MsgBeginRedelegate";
    CosmosSdkMessageType["MsgDelegate"] = "cosmos-sdk/MsgDelegate";
    CosmosSdkMessageType["MsgSend"] = "cosmos-sdk/MsgSend";
    CosmosSdkMessageType["MsgUndelegate"] = "cosmos-sdk/MsgUndelegate";
    CosmosSdkMessageType["MsgWithdrawDelegationReward"] = "cosmos-sdk/MsgWithdrawDelegationReward";
})(CosmosSdkMessageType || (CosmosSdkMessageType = {}));
